(() => {
  const selector = '[data-patch-customizer]';

  const positionAfterProductForm = (root) => {
    if (window.Shopify?.designMode) return;
    const slot = document.querySelector('[data-patch-customizer-slot]');
    if (slot) {
      slot.replaceWith(root);
      root.classList.add('patch-customizer--product-form');
      return;
    }
    const productInfo = document.querySelector('product-info') || document.querySelector('.product__info-container');
    const productForm = productInfo?.querySelector('product-form');
    if (!productForm || root.contains(productForm)) return;

    productForm.insertAdjacentElement('afterend', root);
    root.classList.add('patch-customizer--product-form');
  };

  const init = (root) => {
    if (!root || root.dataset.patchCustomizerReady === 'true') return;
    root.dataset.patchCustomizerReady = 'true';
    positionAfterProductForm(root);

    const track = root.querySelector('[data-patch-track]');
    const previousButton = root.querySelector('[data-patch-scroll-prev]');
    const nextButton = root.querySelector('[data-patch-scroll-next]');
    const options = Array.from(root.querySelectorAll('[data-patch-option]'));
    const modalTrack = root.querySelector('[data-patch-modal-track]');
    const modalPreviousButton = root.querySelector('[data-patch-modal-prev]');
    const modalNextButton = root.querySelector('[data-patch-modal-next]');
    const modalOptions = Array.from(root.querySelectorAll('[data-patch-modal-option]'));
    const modal = root.querySelector('[data-patch-modal]');
    const preview = root.querySelector('[data-patch-preview]');
    const selectedTitle = root.querySelector('[data-patch-selected-title]');
    const selectedVariantInput = root.querySelector('[data-patch-variant-input]');
    const addButton = root.querySelector('[data-patch-add-button]');
    const addButtonLabel = root.querySelector('[data-patch-add-label]');
    let returnFocus = null;

    const portalModalToBody = () => {
      if (!modal || modal.parentElement === document.body) return;
      const rootStyles = getComputedStyle(root);
      [
        '--patch-overlay-width',
        '--patch-overlay-x',
        '--patch-overlay-y',
        '--patch-overlay-width-mobile',
        '--patch-overlay-x-mobile',
        '--patch-overlay-y-mobile',
      ].forEach((property) => modal.style.setProperty(property, rootStyles.getPropertyValue(property)));
      document.body.appendChild(modal);
    };

    const updateArrows = () => {
      if (!track || !previousButton || !nextButton) return;
      const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
      previousButton.disabled = track.scrollLeft <= 2;
      nextButton.disabled = track.scrollLeft >= maxScroll - 2;
    };

    const scrollTrack = (direction) => {
      if (!track) return;
      track.scrollBy({ left: direction * Math.max(track.clientWidth * 0.78, 180), behavior: 'smooth' });
    };

    const updateModalArrows = () => {
      if (!modalTrack || !modalPreviousButton || !modalNextButton) return;
      const maxScroll = Math.max(0, modalTrack.scrollWidth - modalTrack.clientWidth);
      modalPreviousButton.disabled = modalTrack.scrollLeft <= 2;
      modalNextButton.disabled = modalTrack.scrollLeft >= maxScroll - 2;
    };

    const scrollModalTrack = (direction) => {
      if (!modalTrack) return;
      modalTrack.scrollBy({ left: direction * Math.max(modalTrack.clientWidth * 0.72, 150), behavior: 'smooth' });
    };

    const closeModal = () => {
      if (!modal || modal.hidden) return;
      modal.hidden = true;
      document.body.classList.remove('patch-customizer-is-open');
      root.appendChild(modal);
      if (returnFocus) returnFocus.focus();
    };

    const selectPatch = (option) => {
      if (!preview) return false;
      const imageUrl = option.dataset.patchPreviewImage;
      const title = option.dataset.patchTitle || '';
      const variantId = option.dataset.patchVariantId || '';
      if (!imageUrl) return false;

      [...options, ...modalOptions].forEach((item) => {
        item.classList.toggle('is-selected', item.dataset.patchTitle === title);
      });
      preview.src = imageUrl;
      preview.alt = title;
      preview.hidden = false;
      if (selectedTitle) selectedTitle.textContent = title;
      if (selectedVariantInput) selectedVariantInput.value = variantId;
      if (addButton) addButton.disabled = !variantId;
      if (addButtonLabel) addButtonLabel.textContent = variantId ? `${title} sepete ekle` : 'Bu set şu anda mevcut değil';

      return true;
    };

    const openModal = (option) => {
      if (!modal || !selectPatch(option)) return;

      returnFocus = option;
      portalModalToBody();
      modal.hidden = false;
      document.body.classList.add('patch-customizer-is-open');
      updateModalArrows();
      modal.querySelector('[data-patch-close]')?.focus();
    };

    previousButton?.addEventListener('click', () => scrollTrack(-1));
    nextButton?.addEventListener('click', () => scrollTrack(1));
    track?.addEventListener('scroll', updateArrows, { passive: true });
    modalPreviousButton?.addEventListener('click', () => scrollModalTrack(-1));
    modalNextButton?.addEventListener('click', () => scrollModalTrack(1));
    modalTrack?.addEventListener('scroll', updateModalArrows, { passive: true });
    window.addEventListener('resize', () => {
      updateArrows();
      updateModalArrows();
    });

    options.forEach((option) => option.addEventListener('click', () => openModal(option)));
    modalOptions.forEach((option) => option.addEventListener('click', () => selectPatch(option)));
    root.querySelectorAll('[data-patch-close]').forEach((button) => button.addEventListener('click', closeModal));

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && modal && !modal.hidden) closeModal();
    });

    updateArrows();
    updateModalArrows();
  };

  const initAll = (scope = document) => scope.querySelectorAll(selector).forEach(init);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
